import { usePermissions } from "../../../../../../../server/auth/use-permissions";
import { useFlag } from "../../../../../../../server/optimizely";
import { useSupabaseLoader } from "../../../../../../../server/supabase/hooks";
import type {
  SupabaseHandlerArg,
  UseSupabaseLoaderState,
} from "../../../../../../../server/supabase/hooks/types";
import type { UUID } from "../../../../../../../utils/uuid";
import type { PreviewMomentData } from "../types";

export function useMomentPreviewData(momentId: UUID): UseSupabaseLoaderState<PreviewMomentData> {
  const { reviewer } = usePermissions();
  const [reviewExperienceEnabled] = useFlag("reviewer_role");
  const useReviewerSchema = reviewExperienceEnabled && reviewer;

  return useSupabaseLoader<PreviewMomentData, "public" | "reviewer">(
    async ({ supabase, account_id }): Promise<PreviewMomentData> => {
      const args = { moment_id_: momentId, account_id_: account_id };
      const { data, error } = await (
        useReviewerSchema
          ? (supabase as SupabaseHandlerArg<"reviewer">["supabase"]).rpc(
              "assigned_moment_preview",
              args,
            )
          : (supabase as SupabaseHandlerArg<"public">["supabase"]).rpc("moment_preview_data", args)
      ).single();

      if (error) throw error;
      return data;
    },
    [momentId, useReviewerSchema],
    useReviewerSchema ? "reviewer" : "public",
  );
}
